// A small wrapper for messages that we return for signalR errors (as they often lack any message aside from status code)
export enum CommonSignalRErrors {
  Negotiate = "Failed to negotiate",
}

export interface ErrorSignalR {
  statusCode: number;
  message: string;
}

export const ToErrorSignalR = (statusCode: number, message: string) => {
  return {
    statusCode,
    message,
  } as ErrorSignalR;
};
